import { createPortal } from 'react-dom';
import { Theme } from '../lib/themes';

interface DeleteConfirmationModalProps {
  show: boolean;
  title: string;
  message: string;
  itemPreview?: string;
  onConfirm: () => void;
  onCancel: () => void;
  theme: Theme;
}

export default function DeleteConfirmationModal({
  show,
  title,
  message,
  itemPreview,
  onConfirm,
  onCancel,
  theme,
}: DeleteConfirmationModalProps) {
  if (!show) return null;

  return createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: theme.colors.surface,
          borderRadius: '0.75rem',
          boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
          width: '100%',
          maxWidth: '24rem',
          padding: '1.5rem',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1.25rem' }}>
          <div style={{
            flexShrink: 0,
            width: '2.5rem',
            height: '2.5rem',
            borderRadius: '9999px',
            backgroundColor: 'rgba(239, 68, 68, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="#ef4444" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ fontSize: '1.05rem', fontWeight: 600, color: theme.colors.text, marginBottom: '0.35rem' }}>
              {title}
            </h3>
            <p style={{ fontSize: '0.875rem', color: theme.colors.textSecondary, lineHeight: 1.5 }}>
              {message}
            </p>
          </div>
        </div>

        {itemPreview && (
          <div style={{
            padding: '0.625rem 0.875rem',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
            color: theme.colors.textSecondary,
            backgroundColor: theme.colors.background,
            marginBottom: '1.25rem',
            lineHeight: 1.5,
          }}>
            {itemPreview.length > 150 ? itemPreview.substring(0, 150) + '…' : itemPreview}
          </div>
        )}

        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '0.5rem',
              fontWeight: 500,
              fontSize: '0.875rem',
              backgroundColor: theme.colors.background,
              color: theme.colors.text,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '0.5rem',
              fontWeight: 500,
              fontSize: '0.875rem',
              backgroundColor: '#ef4444',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
